import type { CatalogCategoryKindType } from '@econtractor/types';

const storageKey = (userId: number, kind: CatalogCategoryKindType): string =>
    `voltox-${userId}-${kind}-category-filter`;

const normalizeIds = (value: unknown): number[] => {
    if (!Array.isArray(value)) return [];
    const ids = value
        .map((id) => Number(id))
        .filter((id) => Number.isInteger(id) && id > 0);
    return Array.from(new Set(ids));
};

export const loadCatalogCategoryIds = (userId: number, kind: CatalogCategoryKindType): number[] => {
    if (!userId || typeof window === 'undefined') return [];
    try {
        const raw = window.localStorage.getItem(storageKey(userId, kind));
        if (!raw) return [];
        return normalizeIds(JSON.parse(raw));
    } catch {
        return [];
    }
};

export const saveCatalogCategoryIds = (
    userId: number,
    kind: CatalogCategoryKindType,
    ids: number[],
): void => {
    if (!userId || typeof window === 'undefined') return;
    try {
        const normalized = normalizeIds(ids);
        if (!normalized.length) {
            window.localStorage.removeItem(storageKey(userId, kind));
            return;
        }
        window.localStorage.setItem(storageKey(userId, kind), JSON.stringify(normalized));
    } catch {
        /* ignore quota / private mode */
    }
};
